import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import tempTable from '@/components/rw/tempTable/index';
import tempSearch from '@/components/rw/tempSearch/index';
import tempForm from '@/components/rw/tempForm/index';
import tempChart from '@/components/rw/tempChart/index';
import setting from '@/setting';
import { staticTotal } from '../../../../api/apis';
import chartNewMember from './chartNewMember';
import chartGrade from './chartGrade';
import chartVisits from './chartVisits';
export default {
  components: {
    tempTable: tempTable,
    tempSearch: tempSearch,
    tempForm: tempForm,
    tempChart: tempChart,
    chartNewMember: chartNewMember,
    chartGrade: chartGrade,
    chartVisits: chartVisits
  },
  data: function data() {
    return {
      title: setting.projectName,
      numberListTotal: [{
        color: '#ff5c87',
        icon: 'el-icon-coin',
        value: '0',
        unit: '￥',
        title: '累计销售盒数'
      }, {
        color: '#759aff',
        icon: 'el-icon-pie-chart',
        value: '0',
        unit: '￥',
        title: '累计会员数'
      }, {
        color: '#f59821',
        icon: 'el-icon-user',
        value: '0',
        title: '云仓总盒数'
      }],
      remoteFunc: {}
    };
  },
  created: function created() {},
  mounted: function mounted() {
    var _this = this;

    staticTotal({}).then(function _callee(res) {
      return regeneratorRuntime.async(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.$refs.visits.update(res.login_group);

              _this.$refs.grade.update(res.grade_group);

              _this.$refs.member.update(res.user_day_group);

              _this.numberListTotal[0].value = res.total_num;
              _this.numberListTotal[1].value = res.total_member;
              _this.numberListTotal[2].value = res.yun_cang_num;

            case 6:
            case "end":
              return _context.stop();
          }
        }
      });
    });
  },
  beforeDestroy: function beforeDestroy() {},
  methods: {}
};